import React from 'react';
import PropTypes from 'prop-types';
import DefaultSelectV2 from '../DefaultSelectV2';

const ValidateSelectV2 = ({ error, onChange, value, disabled, isRequired, showEmpty }) => (
  <DefaultSelectV2
    error={error}
    disabled={disabled}
    handlerOption={(option) => option.descricao}
    isRequired={isRequired}
    label="Validado"
    name="validate"
    onSelect={(e) => onChange(e.target.value ? e.target.value : null)}
    options={[
      { id: 'AGUARDANDO_VALIDACAO', descricao: 'Aguardando Validação' },
      { id: 'VALIDADO', descricao: 'Validado' },
      { id: 'INVALIDADO', descricao: 'Invalidado' },
    ]}
    showEmpty={showEmpty}
    value={value}
  />
);

ValidateSelectV2.propTypes = {
  error: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  isRequired: PropTypes.any,
  showEmpty: PropTypes.bool,
};
ValidateSelectV2.defaultProps = { value: '', showEmpty: false, onChange: () => {} };
export default ValidateSelectV2;
